import Footer from '../Components/Footer'
import { motion } from "framer-motion"
import DrawerAppBar from '../Components/DrawerAppBar';
import Menus from '../Components/Menus';
import TitrePage from '../Components/TitrePage';
import NosAgences from '../Components/NosAgences';

interface Props { }

function Agences(props: Props) {
                

    

    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre43'} lien={'Label.Titre.titre12'} />
            <br /><br /><br /><br /><br /><br /><br /><br /><br />
            

            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
            >
                <center>
                    <NosAgences />
                </center>
            </motion.div>
            <br /><br />

            <br /><br /><br />



            <Footer />
        </div>
    )
}
export default Agences